export default __webpack_public_path__ + "static/media/ben.8b5f423c.png";